module.exports = __webpack_public_path__ + "static/media/2.21d4871c.jpg";